'use client';

import { useMemo, type ReactNode } from 'react';
import { BookCatalogProvider } from '@sharpr/ui';
import type { Book } from '@sharpr/types';
import { useBookCatalog } from '@/hooks/useBookCatalog';

/** The book catalog for the tree: the server's prefetch at first paint, then the live `/api/books` (so a failed prefetch recovers). */
export function LiveBookCatalogProvider({ books, children }: { books: readonly Book[] | null; children: ReactNode }) {
  return (
    <BookCatalogProvider books={books}>
      <LiveCatalog>{children}</LiveCatalog>
    </BookCatalogProvider>
  );
}

function LiveCatalog({ children }: { children: ReactNode }) {
  const catalog = useBookCatalog();
  const books = useMemo(() => [...catalog.values()], [catalog]);
  return <BookCatalogProvider books={books}>{children}</BookCatalogProvider>;
}
